module.exports = __webpack_public_path__ + "img/heart_10.bb35f88b.png";